import { useAuthStore } from '@/store/authStore'
import type { UserRole } from '@brix/types'

export interface Permissions {
  // Navigation / sections
  canAccessSites: boolean      // create & manage sites and pages
  canAccessBlog: boolean       // create & manage blog posts
  canAccessSettings: boolean   // workspace settings
  canAccessBilling: boolean    // billing (owner only)
  canAccessTeam: boolean       // team member management

  // Blog granularity
  isAuthorOnly: boolean        // can only edit own posts (author role)

  // Destructive actions
  canDeleteSite: boolean
  canDeleteWorkspace: boolean  // owner only

  role: UserRole | null
}

const BLOG_ROLES: UserRole[] = ['owner', 'admin', 'editor', 'author']
const MANAGE_ROLES: UserRole[] = ['owner', 'admin']

export function usePermissions(): Permissions {
  const role = useAuthStore(s => s.userRole)

  const has = (allowed: UserRole[]) => role !== null && allowed.includes(role)

  return {
    canAccessSites:    has(MANAGE_ROLES),
    canAccessBlog:     has(BLOG_ROLES),
    canAccessSettings: has(MANAGE_ROLES),
    canAccessBilling:  role === 'owner',
    canAccessTeam:     has(MANAGE_ROLES),

    isAuthorOnly: role === 'author',

    canDeleteSite:      has(MANAGE_ROLES),
    canDeleteWorkspace: role === 'owner',

    role,
  }
}
